export default __webpack_public_path__ + "static/coniferous-champion-a695da1a9fdff9a412a039ad0948916b.png";